import { Row, Col, Form, Button, Radio } from 'antd';
import React, { ReactElement, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  authFeatureConstants, createGuidelineItems, createOnMailGuidelineItems, DRAFT_CHANGE_STATUSES,
  GUTTOR_SPACE, ID, ROUTE_CHANGE_CONFIRMATION_MESSAGE,
} from '../../../../shared/constants/commonConstants';
import './newAdmission.less';
import { ADMISSION_FORM_TYPES, AUTOMATION_CANCELLED_INFO, DEFAULT_ADMISSION_FORM_VALUE,
  NOTIFICATION_TYPE, QUERY_DRAFT_FLOW, VALUE_NOT_UPDATED } from '../../../../shared/constants/crmConstants';
import CustomFormStepper from './panels/CustomFormStepper/CustomFormStepper';
import { RootState } from '../../../../store';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import {
  setSelectedTab,
  setAdmissionForm,
  setSelectedBeneficiary,
  setIsShowAdmissionForm,
  setUploadedFiles,
  setIsMinimize,
  setIsSubmitClicked,
  setBeneficiaryList,
  updatePackageSelection,
  setIsComponentRendered,
  setIsDraftSelected,
  setClassificationArray,
  setbillAmountArray,
  updateDefaultTimeline,
  toggleOtherProcedure,
  toggleFileUploadByForce,
  setAdmissionFormType,
  enableManualSubmission,
  setIsLoadingPreData,
  updateAdmissionStartTime,
  setsubmitDisabled,
  setBeneficiarySearchResponsePayerId,
  setShowPayerUpdatedMessage,
  setIsSuccessModalNewAdmission,
  setIsSubmitClickedFromModal,
  setInsurerID,
  setIsArtemis,
} from './../../../../store/actions/newAdmissionAction';
import { clearNewAdmissionState } from '../../../../store/actions/newAdmissionAction';
import { fetchClaimDetails, setClaimData, setClaimMandatoryClassifications } from '../../../../store/actions/claimDetailsAction';
import { base64UrlDecode, canActivate, centeredNotification, emptyFunction, isGroupUser, handleResize } from '../../../../utils/utility';
import { clearPayerLookUp, fetchDiagnosisLookup,
  fetchLookUpValues } from '../../../../store/actions/lookUpAction';
import { Prompt, useHistory } from 'react-router';
import {
  convertToISOStrings,
  fileUploadCheck, fillFormValuesFromBenef, fillFormValuesFromHIS, findSelectedPayer, getAdmissionFormType, getDetailNav,
  getInsurerDetails,
  getIsPageNameNewAdmission, getParsedAttributesObject, getPreviousUrl, mapHISDataToFormFields, prefillPayer, reArrangeOptions,
} from '../service/crmUtils';
import { cloneDeep, isEmpty, isEqual } from 'lodash';
import BuddhiMedFileUploadModal from '../../../../shared/components/fileUpload/buddhimedFileUploadModal/BuddhiMedFileUploadModal';
import { useMigrateClaimDetail } from '../../../../shared/hooks/useMigrateClaimDetail';
import { PayerInitialState } from '../../../../store/models/payerListModel';
import { Payer } from '../../../../shared/models/payer.model';
import { changePayer, setAllPayers } from '../../../../store/actions/payerListAction';
import { lockUnlockOrDeleteDraft, updateDraftId, updateSaveDraftStatus } from '../../../../store/actions/savedDraftAction';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { getDefaultTimeline } from '../../../../utils/dateTimeUtils';
import Panel from '../../../../shared/components/card/Panel';
import PayerList from '../../../../shared/components/payerList/PayerList';
import MultipayerFormWrapper from './panels/multipayerFormWrapper/multiPayerFormWrapper';
import useSetDefaultPayer from '../../../../shared/hooks/useSetDefaultPayer';
import moment from 'moment';
import { getHospDetail, setUserAuthData } from '../../../../store/actions/authAction';
import {
  setHospitalPatientSearchDetails, setPatientSearchDetail,
  setHISDoctorList, getHISDoctorsList, setIsHISClaim,
  setHISCardSelected,
  setSuggestedValuesMap,
  setAutomatedNewAdmission,
  setIsHISPackageFilled,
  setParsedHISValuesMap,
} from '../../../../store/actions/hospitalAction';
import { decryptText } from '../../../../utils/encryptDecrypt';
import ConsentModal from './panels/ConsentModal/ConsentModal';
import { FormInstance } from 'antd/lib/form';
import { MailboxType } from '../../../../store/models/mailBoxModel';
import NewAdmissionFooter from './newAdmissionFooter';
import { clearNHCXState, setPayerDropDownVisible, setPolicySearchResults, setSelectedPolicyDetail } from '../../../../store/actions/nhcxAction';
import { NHCXState } from '../../../../store/models/nhcxModel';
import BlueBgInformativeAlert from '../../../../shared/components/Alert/BlueBgInformativeAlert';
import { fetchPayerConfig } from '../../../../store/actions/mailBoxAction';
import HISSearchCards from './panels/cardPanels/HISSearchCards';
import PolicySearchCards from './panels/cardPanels/PolicySearchCards';
import BeneficiarySearchCards from './panels/cardPanels/BenficiarySearchCards';
import { ReactComponent as PolicySearchIcon } from '../../../../assets/images/svg/Poliy_Search_Icon.svg';

import BeneficiarySearchRedesign from './panels/BeneficiarySearch/BeneficiarySearchRedesign';
import PolicySearchRedesign from './panels/BeneficiarySearch/PolicySearchRedesign';
import { ReactComponent as Disabled_PolicyIcon } from '../../../../assets/images/svg/Disabled_PolicyIcon.svg';
import HISSearchPanel from './panels/SearchPanels.tsx/HISSearchPanel';
import CustomGuideline from '../../../../shared/components/Guidelines/customGuideline';
import IdCardGuide from '../../../../shared/components/timeline/IdCardGuide';
import PolicyDetailsGuide from '../../../../shared/components/timeline/PolicyDetailsGuide';
import IPODetailsGuide from '../../../../shared/components/timeline/IPODetailsGuide';
import StepHeader from '../../../../shared/components/Guidelines/stepHeader';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import FileUploadMinimize from '../../../../shared/components/fileUpload/FileUploadMinimize';
import DetailTimeline from './panels/cards/DetailTimeline/DetailTimeline';
import HisSuccessModal from './panels/SuccessModal/HisSuccessModal';
import PageHeaderRedesign from '../../../../shared/components/pageHeader/PageHeaderRedesign';
import LeftHeaderCtaAction from './panels/HeaderRightActions/LeftHeaderCtaAction';
import RightHeaderCtaAction from './panels/HeaderRightActions/RightHeaderCtaAction';
import AutomationLoaderModal from '../../../../shared/components/modal/NAAutomationLoaderModal/AutomationLoaderModal';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../config/formControlConfig';

const NewAdmissionRedesign = ({ match, location: { pathname } }: any, form: FormInstance): ReactElement | null => {
  const mounted = useRef(false);
  const { payerConfiguration }: MailboxType =
    useSelector((state: RootState): MailboxType => state.mailBox);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isLookUpLoading, setIsLookUpLoading] = useState(false);
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [isBackPressed, setIsBackPressed] = useState(false);
  const [originalClaimDetail, setOriginalClaimDetail] = useState({});
  const [hospitalCenterId, setHospitalCenterId] = useState<any>({});
  const [text, setText] = useState<any>([]);
  const buddhimedModalRef = useRef<any>();
  const history = useHistory();
  const isHISSearchEnabled = ApplicationDetail.instance.getIsHISSearchEnabled();
  const isPreAuthNewDesignEnabled = ApplicationDetail?.instance?.getIsPreAuthNewDesignEnabled();
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const [admissionForm] = Form.useForm();
  const [buddhimedForm] = Form.useForm();
  const [baseForm] = Form.useForm();
  const { payerDropDownVisible, ipoResponse } = useSelector((state: RootState): NHCXState => state.nhcx);
  const dispatch = useDispatch();
  const claimDetailResponse = JSON?.parse(localStorage?.getItem('claimDetailResponse') || '{}');
  useMigrateClaimDetail(isDetailLoading, isLookUpLoading, originalClaimDetail);
  const setDefaultPayer = useSetDefaultPayer();
  const {
    selectedTab,
    admissionFormVal,
    isShowAdmissionForm,
    uploadedFiles,
    isDraftSelected,
    existingClaimError,
    newAdmissionSearchValues,
    admissionFormType,
    resetDetailNav,
    selectedCenter,
    hospitalWisePayerList, isSuccessModalNewAdmission,
    toggleClick, selectedBeneficiaryDetail, updatedMemberName,
    showBeneficiaryCard, beneficiaryList, searchType: memberSearchType, isArtemis,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { customerDetail, treatmentDetail, billDetail } = admissionFormVal || {};
  const isLoading = isLookUpLoading || isDetailLoading;
  const { params: { claimDetail } } = match;
  const { claimDetails, isArtemisClaim, claimDetails: { patientName } } = useSelector((state: RootState): any =>
    state.admissionDetails);
  const { payer, payer: { shortName, isMemberSearchImageAllowed } } = useSelector((state: RootState): PayerInitialState =>
    state.payerList);
  const { isBenefSearchEnabled, id, uniqueIdentifier } = payer || {};
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const { selectedDraftId } = useSelector((state: RootState): any => state.savedDraft);
  const groupProviders = appDetail.getGroupProviders();
  const appDetailService = ApplicationDetail.instance;
  const isNewAutomationEnabled = appDetailService.getIsNewAutomationEnabled();
  const [detailNav, setDetailNav] = useState(getDetailNav(isNewAutomationEnabled, payer));
  const [hospitalWisePayer, setHospitalWisePayer] = useState([]);
  const [verified, setVerified] = useState(true);
  const [HISOption, setHISOption] = useState();
  const [isCenterSelected, setIsCenterSelected] = useState(false);
  const [is150PercentZoom, setIs150PercentZoom] = useState(false);
  const [onPanelLeave, setPanelLeave] = useState(false);
  const [isHISFields, setIsHISFields] = useState<{ name: string }[]>([]);
  const [isHISLoading, setIsHISLoading] = useState(true);
  const [isPolicyLoading, setIsPolicyLoading] = useState(true);
  const [isHISDataFound, setIsHISDataFound] = useState(false);
  const { nextAllowStatus } = claimDetails || {};
  const { draftValue } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { selectedPatientDetail, hospitalSearchValues, isAutomatedNewAdmission,
    suggestedValuesMap } = useSelector((state: RootState): any => state?.hospital);
  const { selectedPolicyDetail, cardChanged, memberName, radioValue }: any =
    useSelector((state: RootState): NHCXState => state?.nhcx);
  const { beneficiarySearchResponsePayerId, showPayerUpdatedMessage, isDateApplied }: any =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const logoutBtnClicked = useSelector(
    ({ hospital: { isLogOutBtnClicked } }: any): any => isLogOutBtnClicked,
  );
  const isPageNameNewAdmission = getIsPageNameNewAdmission(pathname);
  const { payerLookUp }: any = useSelector((state: RootState): RootState => state);
  const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();

  const { payerConfiguration: payerConfig = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { payers } = payerConfig || {};
  const payerFormConfiguration = CONTROL_CONFIG_BASED_ON_PAYER[payer?.name];
  const payerConfigValues = Object.values(payerFormConfiguration || '');
  const [selectedOption, setSelectedOption] = useState('');
  const [searchType, setSearchType] = useState('mobile');
  const [isPolicyDataFound, setIsPolicyDataFound] = useState(false);
  const [isHISSearchActivated, setIsHISSearchActivated] = useState(isHISSearchEnabled);
  const [fieldCompletion, setFieldCompletion] = useState({
    searchActivation: false,
    patientCard: false,
    memberOrPolicy: false,
    policyCard: false,
    memberSearch: false,
    claimReviewed: false,
    documentsAttached: false,
    submitClaim: false,
    memberCard: false,
  });

  const [isFixed, setIsFixed] = useState(true); // Controls the fixed class
  const [showGuideline, setShowGuideline] = useState(true); // Controls showing the main guideline
  const [showNewGuideline, setShowNewGuideline] = useState(false); // Controls showing the new guideline
  const [payerNotConfigured, setPayerNotConfigured] = useState(false);
  const [notConfiguredPayerName, setNotConfiguredPayerName] = useState('');
  const [isHISVisitError, setIsHISVisitError] = useState(false);

  const showIdCardGuide = isPageNameNewAdmission && isMemberSearchImageAllowed && ID[shortName][memberSearchType];
  const showPolicyAndIPOGuides = isNHCXEnabledProvider && selectedTab === 2 && !isEmpty(ipoResponse);
  const isOnMailPayer = payer?.isOnMailPayer;
  const { hisid, integrationSystemFields: hisSearchFields} = appDetail?._applicationDetail?.hospitalDetail?.providerConfigurableProperties;
  const { patientDetails } = selectedPatientDetail || {};
  const { providerId: providerIdentifier } = appDetail?._applicationDetail?.hospitalDetail;
  const { payerID, insurerID } = patientDetails || {};
  const [payerNameFromHIS, setpayerNameFromHIS] = useState('');
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const ARTEMIS_PAYER = payerConfigValues.filter(({type}: any): boolean => type === 'ARTEMIS')?.length;

  const { guidelineItems, spanText } = useMemo((): any => {
    const searchFlowType =
      isEmpty(selectedPolicyDetail) && (isEmpty(selectedPatientDetail) && !isHISVisitError) && selectedOption === 'insurance'
        ? 'default'
        : !isHISSearchActivated || (selectedOption && (isEmpty(selectedPatientDetail) && !isHISVisitError))
        ? 'NHCX'
        : isHISSearchActivated && selectedOption === 'insurance'
        ? 'HIS-W/O-NHCX'
        : 'HIS';

    const isOnMail = payer?.isOnMailPayer;

    return {
      guidelineItems: isOnMail
        ? createOnMailGuidelineItems(searchFlowType, fieldCompletion)
        : createGuidelineItems(searchFlowType, fieldCompletion),
      spanText: {
        default: 'Claim Submission via Beneficiary Search',
        NHCX: 'Claim Submission via NHCX',
        'HIS-W/O-NHCX': 'Claim Submission Using HIS Search',
        HIS: 'Claim Submission Using HIS Search',
      }[searchFlowType],
    };
  }, [selectedOption, isHISSearchActivated, selectedPatientDetail, payer, selectedPolicyDetail, fieldCompletion]);

  const completeStep = useCallback((stepKey: keyof typeof fieldCompletion): any => {
    setFieldCompletion((prev: any): any => ({ ...prev, [stepKey]: true }));
  }, []);

  const resetStep = useCallback((stepKey: keyof typeof fieldCompletion): any => {
    setFieldCompletion((prev: any): any => ({ ...prev, [stepKey]: false }));
  }, []);

  // Find if the previous step before claimReviewed is completed
  const claimReviewedIndex = guidelineItems?.findIndex((item: any): any => item?.key === 'claimReviewed');
  const isClaimReviewedActive = claimReviewedIndex > 0 && guidelineItems[claimReviewedIndex - 1]?.completed;

  const totalSteps = guidelineItems?.reduce((count: any, item: any): number => count + (item?.subStep ? 1 : 0),
    isOnMailPayer ? guidelineItems?.length : guidelineItems?.length - 1);

  const isHISFlow = isHISSearchActivated && hisid === '3';

  const insuranceRadioButtonClassName = isHISFlow ? 'HIS-insurance-radio' : 'insurance-radio';
  const NHCXRadioButtonClassName = isHISFlow ? 'HIS-NHCX-radio' : 'NHCX-radio';

  const isNewAdmissionOnBehalf = canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && isGroupUser();

  const resetMultipleSteps = useCallback((stepKeys: (keyof any)[]): any => {
    setFieldCompletion((prev: any): any => {
      const updatedState: any = { ...prev };
      stepKeys.forEach((key: any): any => {
        updatedState[key] = false;
      });
      return updatedState;
    });
  }, []);

  useEffect((): void => {
    // If the IDCardGuide is shown, hide the guideline and remove the fixed class
    if (showIdCardGuide && !isClaimReviewedActive) {
      setIsFixed(false);
    } else if (isClaimReviewedActive) {
      setShowGuideline(true); // Show guideline
      setIsFixed(true); // Fix guideline if claimReviewed is active and IDCard is not shown
    } else {
      setShowGuideline(true);
      setIsFixed(true);
    }
  }, [showIdCardGuide, isClaimReviewedActive, fieldCompletion]);

  useEffect((): void => {
    if (showPolicyAndIPOGuides) {
      setShowGuideline(false); // Collapse the existing guidelines
      setShowNewGuideline(true); // Show the new guideline with only active and pending steps
    } else if (showPolicyAndIPOGuides && fieldCompletion?.claimReviewed) {
      setShowGuideline(true);
      setShowNewGuideline(false);
    } else {
      setShowGuideline(true);
      setShowNewGuideline(false); // Hide the new guideline if the condition is no longer true
    }
  }, [showPolicyAndIPOGuides, fieldCompletion]);

  // Function to get only active and pending steps
  const getActiveAndPendingSteps = (): any[] => {
    return guidelineItems?.filter((item: any): boolean => !item?.completed === true);
  };

  useEffect((): any => {
    hisfields();
  }, [hisSearchFields]);

  useEffect((): any => {
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = configuredPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (!!finalPayer) {
        dispatch(setShowPayerUpdatedMessage(true));
        setText(['Selected Payer is updated to ', <b key="text1">{finalPayer.name}</b>,
          ' based on the details ', <b key="text2">received from Medi Assist</b>]);
      } else {
        dispatch(setBeneficiaryList([]));
        dispatch(setShowPayerUpdatedMessage(false));
      }
    }
  }, [beneficiarySearchResponsePayerId]);

  useEffect((): void => {
    if (!isHISSearchEnabled && !isNHCXEnabledProvider) {
      setSelectedOption('insurance');
    } else if (!isHISSearchEnabled && isNHCXEnabledProvider) {
      setSelectedOption('NHCX');
    }
  }, []);

  const hisfields = (): any => {
    if (hisSearchFields) {
      const HISFieldsKeys = Object?.keys(JSON.parse(hisSearchFields)?.HISFields);
      const finalData = HISFieldsKeys?.map((item: any): any => ({ name: item, value: item }));
      // to set the 1st option in the list as the default when the form opens
      const defaultOption = finalData?.[0]?.name;
      setHISOption(defaultOption);
      baseForm.setFieldsValue({ 'Fetch Patient Information from HIS': defaultOption });
      if (!isEqual(finalData, isHISFields)) {
        setIsHISFields(finalData);
      }
    }
  };

  const getAllowedAction = (): any => {
    const blockedAction = payer?.blockedActions || '{}';
    const nextStatus = nextAllowStatus?.length > 0 ? nextAllowStatus[0] : isPageNameNewAdmission && 'NEWADMISSION';
    try {
      if ((Object.keys(blockedAction).length) >= 4) {
        centeredNotification(`${payer?.name || 'Selected payer'} has blocked all transactions for ${appDetail.getProviderName()}`);
        return Boolean(blockedAction[nextStatus]);
      } else if (blockedAction[nextStatus]) {
        centeredNotification(`${payer?.name || 'Selected payer'} has blocked Initiating New Admission,
           you can still respond to queries and raise enhancements`);
        return Boolean(blockedAction[nextStatus]);
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };

  useEffect((): void => {
    if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
      setHospitalWisePayer(hospitalWisePayerList);
    }
  }, [hospitalWisePayerList, admissionFormVal]);

  useEffect((): void => {
    const HISPayerID = patientDetails?.payerID;
    if (!isEmpty(payerConfiguration) && HISPayerID) {
      const payerElement = payerConfiguration.find((payerItem: any): boolean => {
        return String(payerItem?.payerID) === HISPayerID;
      });

      if (payerElement && !payerElement.isEnabled) {
        setPayerNotConfigured(true);
        setNotConfiguredPayerName(payerElement.payerName);
      }
    }
  }, [payerConfiguration, selectedPatientDetail]);

  useEffect((): void => {
    if (isEmpty(selectedPatientDetail)) {
      dispatch(setSuggestedValuesMap({}));
      dispatch(setParsedHISValuesMap({}));
      dispatch(setIsHISClaim(false));
      setpayerNameFromHIS('');
      // reseting the admission form during new admission whenever the patient details change;
      if (isPageNameNewAdmission) {
        initiateMemberForm();
      }
    }
  }, [selectedPatientDetail]);

  useEffect((): void => {
    if (!isEmpty(selectedPatientDetail)) {
      // computing insurerName based on insurerID match from payerLookUp
      const insurerNameFromHIS = insurerID ? getInsurerDetails(insurerID, payerLookUp[uniqueIdentifier]) : undefined;

      const mappedSuggestedValues = mapHISDataToFormFields(selectedPatientDetail);
      dispatch(setSuggestedValuesMap({
        ...suggestedValuesMap,
        ...mappedSuggestedValues,
        insurerName: insurerNameFromHIS || VALUE_NOT_UPDATED,
      }));
    }
  }, [selectedPatientDetail, payerLookUp[uniqueIdentifier]]);

  useEffect((): void => {
    const selectedPayer = customerDetail?.payerId || customerDetail?.payer;
    if (isDraftSelected) {
      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
        prefillPayer(selectedPayer, configuredPayers, payers, isDraftSelected, dispatch,
          baseForm, false, initiateMemberForm, changePayer, patientDetails, setIsShowAdmissionForm, setpayerNameFromHIS);
      } else {
        baseForm.setFieldsValue({ payer: selectedPayer });
      }
    } else if (isNHCXEnabledProvider && !isEmpty(selectedPolicyDetail)) {
      baseForm.setFieldsValue({
        payer: selectedPolicyDetail?.payerName,
      });
    }
  }, [customerDetail?.insurerName, isDraftSelected, selectedPolicyDetail]);

  // only used for mapping payers from HIS
  useEffect((): void => {
    if (isHISSearchEnabled && !isEmpty(selectedPatientDetail)) {
      if (selectedOption === 'NHCX') {
        dispatch(setPayerDropDownVisible(false));
      } else if (selectedOption === 'insurance') {
        prefillPayer(payerID, configuredPayers, payers, isDraftSelected, dispatch,
          baseForm, false, initiateMemberForm, changePayer, patientDetails, setIsShowAdmissionForm, setpayerNameFromHIS);
      }
    }
  }, [selectedPatientDetail, radioValue, selectedOption]);

  useEffect((): void => {
    if (isEmpty(selectedPatientDetail) && isEmpty(selectedPolicyDetail)) {
      admissionForm?.setFieldsValue(newAdmissionSearchValues);
    } else {
      if (isNewAdmissionPage && !isDraftSelected) {
        // clearing bill details state
        dispatch(setIsHISPackageFilled(false));
        const parsedHISFieldValues = {
          treatmentAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.treatmentDetails?.additionalAttributes || {}),
          patientDetailsAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.patientDetails?.additionalAttributes || {}),
          caseDetailsAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.caseDetails?.additionalAttributes || {}),
          pastHistoryAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.treatmentPastHistory?.additionalAttributes || {}),
        };
        dispatch(setParsedHISValuesMap(parsedHISFieldValues));
        const formValues = fillFormValuesFromHIS(selectedPatientDetail, selectedPolicyDetail, newAdmissionSearchValues, memberName,
          payerLookUp[uniqueIdentifier], parsedHISFieldValues, payerConfigValues, payer);
        admissionForm?.setFieldsValue(formValues);
        // computing insurerName based on insurerID match from payerLookUp
        const insurerNameFromHIS = insurerID ? getInsurerDetails(insurerID, payerLookUp[uniqueIdentifier]) : undefined;

        const insurerName = newAdmissionSearchValues?.insurerName || insurerNameFromHIS;

        admissionForm?.setFieldsValue({ insurerName });
        dispatch(setInsurerID(insurerID));
      }
    }
    // need to check if the getMaxDoctorList is required, if not this can be removed (not used anywhere now since MAX moved to mithril)
    if (isHISSearchEnabled && !isEmpty(selectedPatientDetail) && hisid === '2') {
      const lastHSPLocationID = parseInt(selectedPatientDetail?.lastHSPLocationID, 10);
      if (lastHSPLocationID > 0) {
        dispatch(getHISDoctorsList({ hospitalId: lastHSPLocationID }));
      }
    }
  }, [newAdmissionSearchValues, selectedPatientDetail, selectedPolicyDetail, payerLookUp]);

  useEffect((): void => {
    if (!isEmpty(selectedPatientDetail) || !isEmpty(selectedBeneficiaryDetail)) {
      const formValues = fillFormValuesFromBenef(selectedPatientDetail, selectedBeneficiaryDetail, selectedPolicyDetail);
      admissionForm?.setFieldsValue(formValues);
    }
  }, [selectedBeneficiaryDetail]);

  useEffect((): void => {
    if (!isEmpty(claimDetails)) {
      const { allowStatus } = claimDetails;
      const docTypesObj: any = {};
      allowStatus?.map(({ actionName, documentName }: any): any => {
        docTypesObj[actionName] = documentName;
        return docTypesObj;
      });
      dispatch(setClaimMandatoryClassifications(docTypesObj));
    }
  }, [claimDetails]);

  const checkVerified = (): any => {
    const PayerListItem: any = payerConfiguration;
    const payerList = PayerListItem['payers'];
    payerList?.map((payerElement: any): any => {
      if (payerElement['payerID'] === payer?.id) {
        if (payerElement['isEnabled']) {
          setVerified(true);
        } else {
          setVerified(false);
        }
      }
    });
    return verified;
  };

  const successCallback = (claimInfo: any): any => {
    if (mounted.current) {
      setIsDetailLoading(false);
      setOriginalClaimDetail(claimInfo);
    }
  };

  const failedCallback = (): any => {
    if (mounted.current) {
      setIsDetailLoading(false);
      dispatch(setClaimData({}));
    }
  };

  const lookUpSuccessCallback = (): void => {
    if (mounted.current) {
      setIsLookUpLoading(false);
      dispatch(setIsLoadingPreData(false));
    }
  };
  const isQueryType = QUERY_DRAFT_FLOW?.some((keyword: any): any => draftValue?.includes(keyword));

  const updateFormType = (selectedPayer: any): any => {
    const formType = getAdmissionFormType(selectedPayer);
    if (formType !== ADMISSION_FORM_TYPES.NORMAL) {
      if (draftValue === 'settlement' || isQueryType) {
        dispatch(toggleFileUploadByForce(false));
      } else {
        dispatch(toggleFileUploadByForce(true));
      }
    }
    dispatch(setAdmissionFormType(formType));
  };

  const handleCancelAutomation = (): void => {
    dispatch(setAutomatedNewAdmission(false));
    centeredNotification(AUTOMATION_CANCELLED_INFO, NOTIFICATION_TYPE.INFO);
  };

  const initiateMemberForm = (): void => {
    if (beneficiarySearchResponsePayerId === 0) {
      dispatch(setBeneficiaryList([]));
    }
    if (!isDraftSelected) {
      dispatch(setBeneficiaryList([]));
    }
    submitNotifier();
    if ((isPageNameNewAdmission || !isEmpty(claimDetails)) && !isDraftSelected) {
      if (!canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)
        && beneficiarySearchResponsePayerId === 0) {
        dispatch(clearNewAdmissionState());
      }
      admissionForm.resetFields();

      dispatch(setIsShowAdmissionForm(false));
      dispatch(toggleOtherProcedure(false));
      dispatch(setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
      dispatch(setUploadedFiles([]));
      dispatch(setClassificationArray([]));
      dispatch(setbillAmountArray([]));
      dispatch(setSelectedTab(0));
      dispatch(setClaimData({}));
      dispatch(updatePackageSelection([]));
    }
    dispatch(setBeneficiarySearchResponsePayerId(0));
  };

  useEffect((): void => {
    if (isHISSearchEnabled) {
      if (payer?.id === 0) {
        setIsNew(false);
      } else {
        setIsNew(true);
      }
    }
    if (payer?.isOnMailPayer && payer?.id !== 0) {
      completeStep('memberOrPolicy');
      completeStep('memberSearch');
    } else {
      if (isEmpty(selectedPolicyDetail)) {
        resetStep('memberOrPolicy');
      }
      resetStep('memberSearch');
    }
    if (!isDraftSelected) {
    dispatch(setIsArtemis(false));
    }
  }, [payer]);

  useEffect((): void => {
    if (id !== 0) {
      setPayerNotConfigured(false);
      // prevent form resetting when newAdmission is through a deeplink
      if (!isAutomatedNewAdmission) {
        initiateMemberForm();
      }
      if (!isDraftSelected) {
        dispatch(setsubmitDisabled(true));
      }
      updateFormType(payer);
      setDetailNav(getDetailNav(isNewAutomationEnabled, payer));
      if (!isBenefSearchEnabled || isOnMailPayer) {
        (draftValue !== 'settlement' && !isQueryType) && dispatch(enableManualSubmission()); // For settlement flow-multipayer
        if (!(selectedOption === 'NHCX') || (selectedOption === 'NHCX' && !isEmpty(selectedPolicyDetail))) {
          dispatch(setIsShowAdmissionForm(true));
          dispatch(setAutomatedNewAdmission(false));
          dispatch(setSelectedBeneficiary(null));
        }
      }
      // removed selectedTab condition and clearing diagnosisDynamicLookup whenever the payer changes
      dispatch(fetchDiagnosisLookup([]));
      dispatch(fetchLookUpValues(lookUpSuccessCallback, uniqueIdentifier));
      dispatch(updateAdmissionStartTime(moment().utcOffset('+05:30').format()));
    }
    setVerified(true);
    checkVerified();
  }, [payer, resetDetailNav, selectedCenter, cardChanged]);

  useEffect((): any => {
    if (groupProviders?.length && hospitalCenterId?.['providerId']) {
      dispatch(fetchPayerConfig(hospitalCenterId?.['providerId']));
    }
  }, [hospitalCenterId]);

  useEffect((): any => {
    if (ARTEMIS_PAYER && isOrionIntegrationEnabledProvider && (isArtemis || isArtemisClaim)) {
    localStorage.removeItem('payerLookUp');
    dispatch(clearPayerLookUp());
    dispatch(fetchLookUpValues(lookUpSuccessCallback, uniqueIdentifier));
  }
}, [isArtemis, isArtemisClaim]);

  useEffect((): any => {
    mounted.current = true;
    return (): boolean => {
      if (window.location.pathname.includes('/new-admission')) {
        return mounted.current = true;
      }
      window.onbeforeunload = emptyFunction;
      window.removeEventListener('popstate', popStateHandler);
      dispatch(setClaimData({}));
      dispatch(clearNewAdmissionState());
      dispatch(setIsComponentRendered(false));
      dispatch(setIsDraftSelected(false));
      dispatch(lockUnlockOrDeleteDraft({ draftId: selectedDraftId, isLocked: false }));
      dispatch(updateDraftId(0));
      dispatch(updateSaveDraftStatus(DRAFT_CHANGE_STATUSES.NO_CHANGE));
      dispatch(updateDefaultTimeline(getDefaultTimeline()));
      dispatch(setIsSuccessModalNewAdmission(false));
      setDefaultPayer();
      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && logoutBtnClicked === false) {
        const providerDetailString: any = decryptText(localStorage?.getItem('providerDetail') || '{}');
        const providerDetail = JSON?.parse(providerDetailString);
        dispatch(setUserAuthData(providerDetail));
      }
      if (isHISSearchEnabled) {
        dispatch(setHospitalPatientSearchDetails([]));
        dispatch(setPatientSearchDetail([]));
        dispatch(setHISCardSelected(false));
        dispatch(setHISDoctorList([]));
      }
      if (isNHCXEnabledProvider) {
        dispatch(clearNHCXState());
      }

      return mounted.current = false;
    };
  }, []);

  useEffect((): any => {
    if (isDraftSelected) {
      dispatch(setIsComponentRendered(true));
    } else {
      initiateMemberForm();
      if (claimDetail) {
        const splittedDetail = base64UrlDecode(claimDetail).split('/');
        const providerId = splittedDetail.length > 6 ? splittedDetail[6] : splittedDetail[5];
        const hospId = [];
        hospId?.push(Number(providerId));

        if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
          dispatch(getHospDetail(hospId, getHospPayersSuccess, getHospFailure));
        } else {
          getClaimDetails(configuredPayers);
        }
      } else {
        setIsNew(true);
      }
    }
    submitNotifier();
    window.addEventListener('popstate', popStateHandler);
  }, [isDraftSelected]);

  useEffect((): void => {
    if (selectedOption !== '') {
      dispatch(setPayerDropDownVisible(true));
      if (isHISSearchActivated && isEmpty(hospitalSearchValues)) {
        setIsHISSearchActivated(false);
      }
      if (selectedOption === 'insurance') {
        dispatch(setPayerDropDownVisible(true));
      }
    }
  }, [selectedOption]);

  useEffect((): void => {
    if (providerIdentifier && isNewAdmissionOnBehalf && !isDraftSelected) {
      const reArrangeCenterOptions =
      reArrangeOptions(
        groupProviders,
        'providerId',
        'providerName',
        {
          isRestRequired: true,
          additionalLabelKey: 'providerRohiniCode',
          additionalLabelKeyDivider: '|',
        },
      );
      const selectedCenterData = (reArrangeCenterOptions || [])?.find((co: any): any => co?.value === providerIdentifier);
      setHospitalCenterId(selectedCenterData);
      setDefaultPayer();
      setIsCenterSelected(true);
    }
  }, [providerIdentifier]);

  const resetNewAdmissionPage = (): void => {
    initiateMemberForm();
    dispatch(setHospitalPatientSearchDetails([]));
    dispatch(setPatientSearchDetail([]));
    setDefaultPayer();
    baseForm.resetFields(['payer']);
    dispatch(setPolicySearchResults([]));
    dispatch(setSelectedPolicyDetail([]));
    setIsPolicyLoading(true);
    resetMultipleSteps(['policyCard', 'memberSearch', 'memberOrPolicy', 'memberCard',
      'claimReviewed', 'documentsAttached', 'patientCard', 'searchActivation']);
    if (isHISSearchEnabled) {
      setSelectedOption('');
      setIsHISLoading(true);
      setIsHISSearchActivated(true);
    } else {
      setSelectedOption('insurance');
    }
  };

  useEffect((): void => {
    if ((!isDraftSelected || isSuccessModalNewAdmission)) {
      resetNewAdmissionPage();
    }
  }, [isSuccessModalNewAdmission, HISOption]);

  const getHospPayersSuccess = (result: any): any => {
    result.rohiniCode = result.providerRohiniCode;
    dispatch(setUserAuthData(result));
    const { configuredPayers: hospWiseConfigurePayers } = result;
    dispatch(setAllPayers(hospWiseConfigurePayers));
    getClaimDetails(hospWiseConfigurePayers);
  };

  const getClaimDetails = (configuredPayersList: any): void => {
    const splittedDetail = base64UrlDecode(claimDetail).split('/');
    const [claimNoEncrypted, actionId, payerId, uniquePayerId, tempProductCode] = splittedDetail;
    const tempClaimNo = base64UrlDecode(claimNoEncrypted);
    const claimNo = (!tempClaimNo || tempClaimNo === 'null' || tempClaimNo === 'undefined') ? undefined : tempClaimNo;
    const productCode = (!tempProductCode || tempProductCode === 'null' || tempProductCode === 'undefined') ? undefined : tempProductCode;
    setIsLookUpLoading(true);
    dispatch(fetchLookUpValues(lookUpSuccessCallback, uniquePayerId));
    dispatch(setIsShowAdmissionForm(true));
    const selectedPayer = findSelectedPayer(configuredPayersList, uniquePayerId);
    if (selectedPayer) {
      dispatch(changePayer(selectedPayer));
      updateFormType(selectedPayer);
      // calling the api when claimdetail data is not there
      if (isEmpty(claimDetails)) {
        dispatch(fetchClaimDetails({
          claimNo,
          actionId: parseInt(actionId, 10),
          payerId: parseInt(payerId, 10),
          productCode,
          successCallback, failedCallback,
        }));
      } else {
        if (!isEmpty(claimDetailResponse)) {
          setIsDetailLoading(false);
          setOriginalClaimDetail(claimDetailResponse);
        } else {
          setIsDetailLoading(false);
          dispatch(setClaimData({}));
        }
      }
      dispatch(updateAdmissionStartTime(moment().utcOffset('+05:30').format()));
    }
  };

  useEffect((): any => {
    if (isFormChanged) {
      window.onbeforeunload = (): string => ROUTE_CHANGE_CONFIRMATION_MESSAGE;
    }
  }, [isFormChanged]);

  const submitNotifier = (): void => {
    setIsFormChanged(false);
    setIsBackPressed(false);
    window.onbeforeunload = emptyFunction;
    detailNav.forEach((element: any): void => {
      element.isTouched = element.isValidated = false;
    });
  };

  const popStateHandler = (ev: PopStateEvent): void => {
    ev.preventDefault();
    setIsBackPressed(true);
  };

  const isFileUploaded = (): boolean => {
    const isUserShouldMoveNext = fileUploadCheck(pathname, uploadedFiles);
    if (!isUserShouldMoveNext) {
      dispatch(setIsMinimize(false));
    }
    return isUserShouldMoveNext;
  };

  const onMemberFormValueChange = ({ fullName }: any): void => {
    if (fullName) {
      const { setFullName = (): void => { } } = buddhimedModalRef.current;
      setFullName(fullName);
    }
    setIsFormChanged(true);
  };

  const onSuccessSubmit = (): void => {
    dispatch(setIsSubmitClicked(false));
    dispatch(setIsSubmitClickedFromModal(false));
    submitNotifier();
    setIsModalVisible(true);
  };

  const taskForAdmissionValBeforeUpdate = (newFormVal: any): any => {
    const { formKey: treatmentDetailKey } = detailNav[1];
    const { formKey: billDetailKey } = detailNav[2];
    if (
      !appDetailService.getIsNewAutomationEnabled() &&
      (newFormVal[treatmentDetailKey]?.roomType !== admissionFormVal[treatmentDetailKey]?.roomType)
    ) {
      dispatch(updatePackageSelection([]));
      newFormVal[billDetailKey] = {
        ...newFormVal[billDetailKey], searchPackage: undefined, Package: undefined,
      };
    }
    const dateRange = admissionForm?.getFieldValue(['stayLength']);
    if (isDateApplied) {
      if (dateRange && Array.isArray(dateRange)) {
        const isoDateRange = convertToISOStrings(dateRange);
        newFormVal[treatmentDetailKey].stayLength = isoDateRange;
      }
    }
    return newFormVal;
  };

  const getAdmissionForm = (): ReactElement => {
    if (payer?.disabled || !verified) {
      return <React.Fragment />;
    }
    if (!payer.isClaimSubmissionDisabled && !getAllowedAction()) {
      if (admissionFormType === ADMISSION_FORM_TYPES.NORMAL) {
        return (
          <>{!isDraftSelected && isShowAdmissionForm &&
            <StepHeader guidelineItems={guidelineItems} stepKey="claimReviewed" isOnMailPayer={isOnMailPayer} />}
            <CustomFormStepper
              commonTabNavigationEnabled={isShowAdmissionForm}
              isLoading={isLoading}
              form={admissionForm}
              buddhimedForm={buddhimedForm}
              detailNav={detailNav}
              formValue={admissionFormVal}
              selectedTab={selectedTab}
              setSelectedTab={(tabIndex: number): any => dispatch(setSelectedTab(tabIndex))}
              setFormValue={setAdmissionForm}
              onValueChange={onMemberFormValueChange}
              tabSwitchExtra={isFileUploaded}
              taskForAdmissionValBeforeUpdate={taskForAdmissionValBeforeUpdate}
              className={isPageNameNewAdmission ? 'NA-normal-panel-height' : 'NA-normal-detail-panel-height'}
              isVisible={isShowAdmissionForm}
              isNewForm={isNew}
            />
          </>
        );
      }
      if (payer?.id && admissionFormType === ADMISSION_FORM_TYPES.MULTIPAYER || admissionFormType === ADMISSION_FORM_TYPES.CORPORATE) {
        return (
          <>{!isDraftSelected && <StepHeader guidelineItems={guidelineItems} stepKey="claimReviewed" isOnMailPayer={isOnMailPayer} />}
            {isShowAdmissionForm && <MultipayerFormWrapper
              form={admissionForm}
              buddhimedForm={buddhimedForm}
              className={isPageNameNewAdmission ? 'NA-multipayer-panel-height' : 'NA-multipayer-detail-panel-height'}
            />}
          </>
        );
      }
    }
    return <React.Fragment />;
  };

  const getHospFailure = (errMsg: string): any => {
    centeredNotification(errMsg);
    setHospitalCenterId({});
  };

  const changeHospInfoSearch = (event: any): any => {
    setHISOption(event);
  };

  useEffect((): any => {
    handleResize(setIs150PercentZoom);
    window.addEventListener('resize', (): void => handleResize(setIs150PercentZoom));
    return (): any => {
      window.removeEventListener('resize', (): void => handleResize(setIs150PercentZoom));
    };
  }, []);

  const handleMouseLeave = (): any => {
    setPanelLeave(false);
  };

  const handleMouseEnter = (): any => {
    setPanelLeave(true);
  };

  const handleActivation = (): void => {
    if (isHISSearchEnabled) {
      resetMultipleSteps(['policyCard', 'memberSearch', 'memberOrPolicy', 'memberCard',
        'claimReviewed', 'documentsAttached', 'patientCard', 'searchActivation']);
      setIsHISSearchActivated(!isHISSearchActivated);
      dispatch(setPolicySearchResults([]));
      dispatch(setSelectedPolicyDetail([]));
      initiateMemberForm();
      if (isHISSearchActivated) {
        // checking for true case to switch to Non-HIS flow since UseState is an async function
        setSelectedOption('insurance');
        initiateMemberForm();
        dispatch(setHospitalPatientSearchDetails([]));
        dispatch(setPatientSearchDetail([]));
        setDefaultPayer();
        baseForm.resetFields(['payer']);
      } else {
        setSelectedOption('');
        setIsHISLoading(true);
      }
    } else {
      return;
    }
  };
  const handleHISSearchSuccess = (): void => {
    setIsHISLoading(false);
    setIsHISDataFound(true);
    setSelectedOption('');
    completeStep('searchActivation');
  };

  const handleHISSearchError = (): void => {
    setIsHISLoading(false);
    setIsHISDataFound(false);
  };

  const handleRadioChange = (event: any): void => {
    setSelectedOption(event.target.value);
    resetMultipleSteps(['policyCard', 'memberSearch', 'memberOrPolicy', 'memberCard']);
    if (isEmpty(selectedPatientDetail)) {
      setIsHISSearchActivated(false);
      dispatch(setHospitalPatientSearchDetails([]));
    }
    if (event.target.value === 'insurance') {
      dispatch(setPolicySearchResults([]));
      dispatch(setSelectedPolicyDetail([]));
    }
    setIsPolicyLoading(true);
    initiateMemberForm();
    setDefaultPayer();
    baseForm.resetFields(['payer']);
  };

  const handleSearchTypeChange = (option: string): void => {
    resetStep('policyCard');
    setSearchType(option);
    dispatch(setPolicySearchResults([]));
    dispatch(setSelectedPolicyDetail([]));
    setDefaultPayer();
    baseForm.resetFields(['payer']);
    initiateMemberForm();
  };

  const handlePolicySearchSuccess = (): void => {
    setIsPolicyDataFound(true);
    completeStep('memberOrPolicy');
    setIsPolicyLoading(false);
  };

  const handlePolicySearchError = (): void => {
    setIsPolicyDataFound(false);
    setIsPolicyLoading(false);
  };

  const renderGuidelines = (): any => {
    if (isDraftSelected) {
      return (
        <>{payer.id !== 0 &&
          <Col md={8} lg={8} xl={8} xxl={6}>
            <FileUploadMinimize />
            <DetailTimeline />
          </Col>
        }
        </>
      );
    }

    return (
      <Col md={8} lg={8} xl={8} xxl={6} className="guideline-position">
        <div
          className={`guideline-container blue ${isFixed && showGuideline && !showPolicyAndIPOGuides || showIdCardGuide ? 'fixed' : ''}`}>
          <Row className={`guideline-header`}>
            <span className="guideline-title">{spanText}</span>
            <Button
              className="guideline-button"
              size="small"
              onClick={(): void => setShowGuideline(!showGuideline)}
              icon={showGuideline ? <MinusOutlined /> : <PlusOutlined />}
            />
          </Row>

          {(showGuideline) && (
            <CustomGuideline
              items={guidelineItems}
              containerClassName="guideline-container"
              className={`guideline-padding ${(!isClaimReviewedActive && showIdCardGuide) ? 'set-max-height' : ''}`} />
          )}
        </div>

        {!isClaimReviewedActive && showIdCardGuide && (
          <div className={`mt-sm end-fix fixed top-225`}>
            <IdCardGuide />
          </div>
        )}

        {showPolicyAndIPOGuides && showNewGuideline && (
          <div className={`mt-md ${!showGuideline ? 'fixed' : 'fixed-relative'}`}>
            {!showGuideline && showNewGuideline && (
              <Row className={`guideline-container new-guideline blue mb-sm`}>
                <CustomGuideline items={getActiveAndPendingSteps()} className="guideline-padding" />
              </Row>
            )}
            <div className="end-fix">
              <PolicyDetailsGuide />
              <IPODetailsGuide />
            </div>
          </div>
        )}
      </Col>
    );
  };

  const renderRedirectButton = (): any => (
    (payer?.isClaimSubmissionDisabled && payer?.payerReDirectionDtails) &&
    <Col md={24} className="text-right">
      <Button type="primary"
        onClick={(): void => {
          window.open(
            JSON.parse(payer?.payerReDirectionDtails || '{}').link,
            '_blank',
          );
        }}
      >
        {
          JSON.parse(payer?.payerReDirectionDtails || '{}')?.lable ||
          'Redirect to Payer'
        }
      </Button>
    </Col>
  );

  return (
    <React.Fragment>
      <PageHeaderRedesign pageTitle={isNew ? 'New Admission' : isDraftSelected ? updatedMemberName :
        patientName || isPageNameNewAdmission ? 'New Admission' : 'Member'}
        backUrl={getPreviousUrl(pathname)} isPreAuthNewDesignEnabled={isPreAuthNewDesignEnabled}
        isNewadmission={isPageNameNewAdmission} id={payer?.id} isShowAdmissionForm={isShowAdmissionForm}
        leftComponent={(): ReactElement => (
        <LeftHeaderCtaAction
          form={admissionForm}
          buddhimedForm={buddhimedForm}
          detailNav={detailNav}
          setIsModalVisible={setIsModalVisible}
          submitNotifier={submitNotifier}
          isFormChanged={isFormChanged}
          selectedSearchOption={selectedOption}
        />
        )}
        rightComponent={(): ReactElement => (
          <RightHeaderCtaAction
            form={admissionForm}
            buddhimedForm={buddhimedForm}
            detailNav={detailNav}
            setIsModalVisible={setIsModalVisible}
            submitNotifier={submitNotifier}
            isFormChanged={isFormChanged}
            selectedSearchOption={selectedOption}
          />
        )}
      />

      <div className={`ant-tabs-content-holder NA-tab-custom-container pb-0 ${(isPreAuthNewDesignEnabled && isDraftSelected) ? 'tab-margin-23' : ''}`}
        data-testid="new-admission">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16} lg={16} xl={16} xxl={18}>
            {
              isPageNameNewAdmission &&
              <Form
                form={baseForm}
                requiredMark="optional"
                layout="vertical"
              >
                {!isDraftSelected &&
                  <StepHeader guidelineItems={guidelineItems} stepKey="searchActivation" isOnMailPayer={isOnMailPayer} />}
                {/* env flag added for HIS */}
                {process.env.REACT_APP_IS_HIS_SEARCH_ENABLED === 'true' &&
                  isPageNameNewAdmission && !isDraftSelected && // His not to be seen in drafts case
                  <HISSearchPanel
                    isHISSearchActivated={isHISSearchActivated}
                    isHISFields={isHISFields}
                    changeHospInfoSearch={changeHospInfoSearch}
                    handleActivation={handleActivation}
                    HISOption={HISOption}
                    baseForm={baseForm}
                    handleHISSearchSuccess={handleHISSearchSuccess}
                    handleHISSearchError={handleHISSearchError}
                    isHISSearchEnabled={isHISSearchEnabled}
                    GUTTOR_SPACE={GUTTOR_SPACE}
                    isLoading={isLoading}
                    setSelectedOption={setSelectedOption}
                    resetMultipleSteps={resetMultipleSteps}
                    resetHISForm={isSuccessModalNewAdmission}
                    onChange={resetNewAdmissionPage}
                  />
                }
                {!isDraftSelected && <StepHeader guidelineItems={guidelineItems} stepKey="patientCard" isOnMailPayer={isOnMailPayer} />}
                {!isDraftSelected && <HISSearchCards
                  form={baseForm}
                  setDefaultPayer={setDefaultPayer}
                  loading={isHISLoading}
                  dataFound={isHISDataFound}
                  setSelectedOption={setSelectedOption}
                  selectedOption={selectedOption}
                  completeStep={completeStep}
                  resetMultipleSteps={resetMultipleSteps}
                  isHISVisitError={setIsHISVisitError}
                />
                }
                {
                  process.env.REACT_APP_IS_NHCX_ENABLED === 'true' &&
                  !isDraftSelected &&
                  isPageNameNewAdmission &&
                  <>
                    {!isDraftSelected &&
                      (!isEmpty(selectedPatientDetail) || selectedOption === 'NHCX' || selectedOption === 'insurance') && (
                        <StepHeader
                          guidelineItems={guidelineItems}
                          stepKey={
                            !isEmpty(selectedPatientDetail) || selectedOption === 'NHCX'
                              ? 'memberOrPolicy'
                              : 'memberSearch'
                          }
                          isOnMailPayer={isOnMailPayer}
                        />
                      )}
                    <Panel className="policySearchPanel">
                      {isEmpty(selectedPatientDetail) ? !selectedOption ? <Disabled_PolicyIcon /> : <PolicySearchIcon /> : ''}
                      <span className="policy-search-panel">
                        <span className="search-text font-family-open-sans">
                          {selectedPatientDetail && isEmpty(selectedPatientDetail) ? 'Search Using :' : 'Submit Using :'}
                        </span>
                        <Radio.Group
                          className="policy-search-radio-group"
                          onChange={handleRadioChange}
                          value={selectedOption}
                        >
                          <Radio className={insuranceRadioButtonClassName} value="insurance" name="insurance" data-testid="insurance">
                            <span className="radio-label">Insurance/TPA</span>
                          </Radio>
                          <Radio className={NHCXRadioButtonClassName}
                            value="NHCX"
                            name="NHCX"
                            data-testid="NHCX"
                            disabled={!isNHCXEnabledProvider}
                          >
                            <span className="radio-label">NHCX</span>
                          </Radio>
                        </Radio.Group>
                        {selectedOption === 'NHCX' && (
                          <span className="policy-radio-btn">

                            <Button
                              type={searchType === 'mobile' ? 'primary' : 'default'}
                              onClick={(): void => handleSearchTypeChange('mobile')}
                              className={`policy-mobile-btn ${searchType === 'mobile' ? 'NHCX-selected-text selected' : 'NHCX-unselected-text unselected'} font-family-open-sans`}
                            >
                              MOBILE
                            </Button>
                            <Button
                              type={searchType === 'abha' ? 'primary' : 'default'}

                              onClick={(): void => handleSearchTypeChange('abha')}
                              className={`policy-abha-btn ${searchType === 'abha' ? 'NHCX-selected-text selected' : 'NHCX-unselected-text unselected'} font-family-open-sans`}
                            >
                              ABHA
                            </Button>
                          </span>
                        )}
                      </span>
                      {selectedOption === 'insurance' && payerDropDownVisible &&
                        <div className="payerDropDownPanel mb-6" onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
                          <Row gutter={GUTTOR_SPACE} className="NA-payerSearchDiv">
                            <PayerList {...{
                              size: 24,
                              form: baseForm,
                              isLoading,
                              hideLabel: true,
                              data: hospitalWisePayer?.length ? hospitalWisePayer : undefined,
                              isCenterSelected,
                              groupProviders,
                              hospitalCenterId,
                              centerId: hospitalCenterId?.['providerId'],
                              className: 'Re-Design-Payer-Dropdown',
                              HISPayerValue: payerNameFromHIS || undefined,
                            }} />
                            {payer?.isClaimSubmissionDisabled && <div className="not-configured-error">
                              {payer?.networkActivationMessage}</div>}
                            {selectedPatientDetail?.patientDetails?.payerID && payerNotConfigured &&
                              <div className="not-configured-error">
                                Enable/Configure {notConfiguredPayerName} to submit the claim</div>}
                            {payer?.disabled && appDetail.getIsNewMailboxConfigEnabled() &&
                              <Col md={24} className="text-right">
                                <Button type="primary"
                                  onClick={(): void => {
                                    history.replace('/profile/mailbox');
                                  }}>
                                  Go To Manage Payers</Button>
                              </Col>}
                            {renderRedirectButton()}
                            {payer?.isBenefSearchEnabled && !(payer?.isClaimSubmissionDisabled) &&
                              // prevent benef modal if claim submission is disabled
                              <Col md={24}>
                                <BeneficiarySearchRedesign
                                  form={baseForm}
                                  completeStep={completeStep}
                                  resetStep={resetStep}
                                  resetSteps={resetMultipleSteps}
                                  admissionForm={admissionForm}
                                />
                              </Col>
                            }
                          </Row>
                        </div>}
                      {selectedOption === 'NHCX' && (
                        <PolicySearchRedesign
                          searchType={searchType}
                          onSearchSuccess={handlePolicySearchSuccess}
                          onSearchError={handlePolicySearchError}
                          resetStep={resetStep}
                          resetMultipleSteps={resetMultipleSteps}
                        />
                      )}
                    </Panel></>
                }
                {isDraftSelected && payerDropDownVisible &&
                  <div className="payerDropDownPanel mb-md" onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
                    <Row gutter={GUTTOR_SPACE} className="NA-payerSearchDiv">
                      <PayerList {...{
                        size: 24,
                        form: baseForm,
                        isLoading,
                        hideLabel: false,
                        data: hospitalWisePayer?.length ? hospitalWisePayer : undefined,
                        isCenterSelected,
                        groupProviders,
                        hospitalCenterId,
                        centerId: hospitalCenterId?.['providerId'],
                        className: 'Re-Design-Payer-Dropdown',
                      }} />
                      {renderRedirectButton()}
                    </Row>
                  </div>}
                {!isDraftSelected && isPolicyDataFound && (
                  <StepHeader guidelineItems={guidelineItems} stepKey="policyCard" isOnMailPayer={isOnMailPayer} />
                )}
                {<PolicySearchCards
                  dataFound={isPolicyDataFound}
                  completeStep={completeStep}
                  resetStep={resetStep}
                  resetMultipleSteps={resetMultipleSteps}
                  policyLoading={isPolicyLoading}
                  selectedOption={selectedOption}
                />}
                {!isDraftSelected && selectedOption === 'NHCX' &&
                  !isEmpty(selectedPolicyDetail) && payerDropDownVisible &&
                  <><StepHeader guidelineItems={guidelineItems} stepKey="memberSearch" isOnMailPayer={isOnMailPayer} />
                    <Panel className="NA-payerDropDownPanel" onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
                      <Row gutter={GUTTOR_SPACE} className="payerSearchDiv">

                        <Col md={5} className="NHCX-member-search">
                          Member Search For
                        </Col>
                        <Col flex="auto" className="NHCX-disabled-payer">
                          <PayerList {...{
                            form: baseForm,
                            isLoading,
                            hideLabel: true,
                            data: hospitalWisePayer?.length ? hospitalWisePayer : undefined,
                            isCenterSelected,
                            groupProviders,
                            hospitalCenterId,
                            centerId: hospitalCenterId?.['providerId'],
                            onPanelLeave,
                            NHCXSearch: true,
                          }} />
                        </Col>
                        {payer?.disabled && appDetail.getIsNewMailboxConfigEnabled() &&
                          <Col md={24} className="text-right">
                            <Button type="primary"
                              onClick={(): void => {
                                history.replace('/profile/mailbox');
                              }}>
                              Go To Manage Payers</Button>
                          </Col>
                        }
                        {renderRedirectButton()}
                        {payer?.isBenefSearchEnabled &&
                          <Col md={24}>
                            <BeneficiarySearchRedesign
                              form={baseForm}
                              completeStep={completeStep}
                              resetStep={resetStep}
                              resetSteps={resetMultipleSteps}
                              admissionForm={admissionForm}
                            />
                          </Col>
                        }
                      </Row>
                    </Panel>
                  </>
                }
                {!isDraftSelected && showBeneficiaryCard && !isEmpty(beneficiaryList) && (
                  <StepHeader
                    guidelineItems={guidelineItems}
                    stepKey={
                      isEmpty(selectedPatientDetail)
                        ? 'memberCard'
                        : isEmpty(selectedPolicyDetail) ? 'memberSearch' : 'memberCard'
                    }
                    isOnMailPayer={isOnMailPayer}
                  />
                )}
                {<BeneficiarySearchCards
                  detailNav={detailNav}
                  completeStep={completeStep}
                  resetStep={resetStep}
                  stepCount={(guidelineItems?.find((item: any): boolean => !item?.completed)?.step ?? guidelineItems?.length) - 1}
                  totalSteps={totalSteps}
                  claimForm={admissionForm}
                />}
              </Form>
            }
            {
              showPayerUpdatedMessage &&
              <div className="flex flex-element justify-center align-center bg-blue-alert">
                <BlueBgInformativeAlert okButtonRequired={true} onClick={(): any => { dispatch(setShowPayerUpdatedMessage(false)); }}
                  text={text} />
              </div>
            }
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24}>
                {getAdmissionForm()}
              </Col>
            </Row>
          </Col>
          {renderGuidelines()}
        </Row>
        {(payer?.id === 0 && !HISOption && (!isNHCXEnabledProvider)) &&
          <Row gutter={GUTTOR_SPACE}>
            <Col md={24} className={is150PercentZoom ? 'footerContent_150zoom' : 'footerContent'}>
              <NewAdmissionFooter />
            </Col>
          </Row>
        }
        {toggleClick && isModalVisible &&
          <ConsentModal />
        }
        {isModalVisible &&
          <HisSuccessModal claimDetail={claimDetail}
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            form={admissionForm}
            isNew={isPageNameNewAdmission} />
        }
        <AutomationLoaderModal
          onCancel={handleCancelAutomation}
          isHISLoading={isHISLoading}
        />
        <Prompt when={((customerDetail || treatmentDetail || billDetail || isBackPressed) && isFormChanged
          && !existingClaimError?.errorMessage)}
          message={'Alert!'} />
      </div>
      <BuddhiMedFileUploadModal
        admissionForm={admissionForm}
        isLoading={isLoading}
        form={buddhimedForm}
        ref={buddhimedModalRef}
        onSuccessSubmit={onSuccessSubmit}
        completeStep={completeStep}
      />
    </React.Fragment>
  );
};

export default NewAdmissionRedesign;
